export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '4.4.0',
};
//# sourceMappingURL=buildEnv.js.map